<header class="ui-page-header">
  <div class="ui-page-header__actions" role="group" [attr.aria-label]="actionsAriaLabel() | uiLabelTranslate">
    <ng-content />
  </div>
</header>
